import { registerTourProduct } from '../onboardingTourFactory';

/**
 * The tour of the "Accounts >> Groups" page.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} {steps: [...], novusPagePath: string|false }
 */
const createTour = (t) => {
  return {
    novusPagePath: 'accounts/groups',
    steps: [
      {
        element: '.onboarding-tour.group-search-container',
        intro: t(
          'You can look for a group and filter your search results, it works the same as the Users page.'
        ),
        novusTrackingId: 'accounts-groups-search'
      }
    ]
  };
};

export const tourName = 'accountsGroupsTour';
registerTourProduct(tourName, createTour);



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/accountsGroupsTour.js